
const uiActions = {
    closeNavDropdown: () => ({
        type: 'CLOSE_NAV_DROPDOWN'
    }),
    toggleContentLoading: value => ({
        type: 'TOGGLE_CONTENT_LOADING',
        payload: {
            value
        }
    }),
    initialContentLoaded: () => ({
        type: 'INITIAL_CONTENT_LOADED'
    }),
    toggleFullScreenPanel: () => ({
        type: 'TOGGLE_FULL_SCREEN_PANEL'
    }),
    toggleMapPanel: () => ({
        type: 'TOGGLE_MAP_PANEL'
    }),
    toggleNavDropdown: () => ({
        type: 'COMMON/NAV/TOGGLE_NAV_DROPDOWN'
    }),
    toggleHelpDropdown: () => ({
        type: 'COMMON/NAV/TOGGLE_HELP_DROPDOWN'
    }),
    toggleMobHelpDropdown: () => ({
        type: 'TOGGLE_MOB_HELP_DROPDOWN'
    }),
    toggleVenueDropdown: () => ({
        type: 'TOGGLE_VENUE_DROPDOWN'
    }),
    toggleMobVenueDropdown: () => ({
        type: 'TOGGLE_MOB_VENUE_DROPDOWN'
    }),
    togglePerfDropdown: () => ({
        type: 'TOGGLE_PERF_DROPDOWN'
    }),
    toggleMobPerfDropdown: () => ({
        type: 'TOGGLE_MOB_PERF_DROPDOWN'
    }),
    toggleInvoiceDropdown: () => ({
        type: 'TOGGLE_INVOICE_DROPDOWN'
    }),
    toggleMobInvoiceDropdown: () => ({
        type: 'TOGGLE_MOB_INVOICE_DROPDOWN'
    }),
    toggleInventDropdown: () => ({
        type: 'TOGGLE_INVENT_DROPDOWN'
    }),
    toggleMobInventDropdown: () => ({
        type: 'TOGGLE_MOB_INVENT_DROPDOWN'
    }),
    toggleAdminHelpDropdown: () => ({
        type: 'TOGGLE_ADMINHELP_DROPDOWN'
    }),
    toggleMobAdminHelpDropdown: () => ({
        type: 'TOGGLE_MOB_ADMINHELP_DROPDOWN'
    }),
    toggleRoomHover: roomId => ({
        type: 'TOGGLE_ROOM_HOVER',
        payload: {
            roomId
        }
    })
};

export default uiActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/uiActions.js